/**
 * Nahrané podklady (účetní závěrky) mezi kroky wizardu.
 *
 * Soubor (File) nejde uložit do stavu wizardu, ten se serializuje do JSON
 * a ukládá s valuací. Stav proto nese jen popis souboru a komentář klienta,
 * samotný soubor drží tento modul po dobu práce v prohlížeči. Krok Finance
 * si ho odtud převezme, aby klient nenahrával závěrky dvakrát.
 */

const soubory = new Map();

export function idSouboru(file) {
  return `${file.name}|${file.size}|${file.lastModified || 0}`;
}

export function ulozSoubor(file) {
  const id = idSouboru(file);
  soubory.set(id, file);
  return id;
}

export function souborPodleId(id) {
  return soubory.get(id) || null;
}

export function odeberSoubor(id) {
  soubory.delete(id);
}

/** Soubory k popisům ze stavu; chybějící (po obnovení stránky) vynechá. */
export function souboryZeZadani(zadani) {
  return ((zadani && zadani.soubory) || [])
    .map(s => souborPodleId(s.id))
    .filter(Boolean);
}
